var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[(_vm.title)?_c('div',{staticClass:"banner"},[_vm._v(_vm._s(_vm._f("uppercase")(_vm.title)))]):_vm._e(),_c('div',{class:_vm.unpadded ? 'content' : 'content padded'},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }